import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { md5 } from './utils/md5'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const bufferToHex = (buffer) =>
  Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')

const sha = async (algo, text) => {
  const data = new TextEncoder().encode(text)
  const digest = await window.crypto.subtle.digest(algo, data)
  return bufferToHex(digest)
}

const HashGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Hash (MD5, SHA-1, SHA-256) | jarder.dev',
    description:
      'Gere hashes MD5, SHA-1 e SHA-256 de um texto, direto no ' +
      'navegador. Grátis, sem enviar nada pra servidor.',
  })

  const [input, setInput] = useState('')
  const [hashes, setHashes] = useState(null)

  const generate = async () => {
    const [sha1, sha256] = await Promise.all([sha('SHA-1', input), sha('SHA-256', input)])
    setHashes({ md5: md5(input), sha1, sha256 })
    trackEvent('tool_generate', { tool: 'hash_generator' })
  }

  const copy = (value) => {
    navigator.clipboard.writeText(value)
    trackEvent('tool_copy', { tool: 'hash_generator' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Hash</h1>
      <p className="tool-disclaimer">
        Tudo processado localmente no seu navegador, nenhum texto é
        enviado para nenhum servidor.
      </p>

      <div className="tool-field">
        <label htmlFor="hash-input">Texto</label>
        <textarea
          id="hash-input"
          rows="4"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>

      <button type="button" className="tool-button" onClick={generate}>
        Gerar hashes
      </button>

      {hashes && (
        <ul className="tool-list" style={{ marginTop: 20 }}>
          {[
            ['MD5', hashes.md5],
            ['SHA-1', hashes.sha1],
            ['SHA-256', hashes.sha256],
          ].map(([label, value]) => (
            <li key={label} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center' }}>
              <span style={{ wordBreak: 'break-all' }}>
                <strong>{label}:</strong> {value}
              </span>
              <button
                type="button"
                className="tool-button tool-button-secondary"
                onClick={() => copy(value)}
              >
                Copiar
              </button>
            </li>
          ))}
        </ul>
      )}

      <div className="tool-info-section">
        <h2>Para que serve um hash</h2>
        <p>
          Um hash é uma "impressão digital" de tamanho fixo gerada a
          partir de um texto  mudar um único caractere na entrada muda
          o hash inteiro. É usado para conferir a integridade de
          arquivos (comparando o hash divulgado com o do arquivo
          baixado), gerar identificadores únicos ou verificar se dois
          textos são idênticos sem comparar o conteúdo inteiro.{' '}
          <strong>MD5 e SHA-1</strong> não são mais recomendados para
          senhas ou segurança (são fáceis de quebrar hoje em dia)  para
          isso, prefira algoritmos como bcrypt ou Argon2.
        </p>
      </div>
    </div>
  )
}

export default HashGenerator
